<template>
  <div>
    <div class="overlay-gradient  service-21 wrap-service21-box bg-question">
      <div class="container overlay-content">
        <!-- Row  -->
        <div class="row text-white ptb">
          <!-- Column -->
          <div class="col-md-5 col-lg-6 col-xl-6">
          </div>
          <div class="col-md-7 col-lg-6 col-xl-6">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h1 class="title-home mb-3 text-dark-tc">
                  ¿TIENES DUDAS?
                </h1>
                <p class="pl-0 text-dark-tc">
                  Si tienes dudas de nuestros servicios puedes ver las preguntas
                  más frecuentes o enviarnos un correo electrónico
                </p>
              </div>
              <div class="col-12 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-primary" @click="redirectPage">
                  <span class="title-home">
                    Preguntas Frecuentes
                  </span>
                </button>
              </div>
              <div class="col-12 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-primary">
                  <font-awesome-icon :icon="['fas', 'envelope']" />
                  <span class="title-home">
                    info@totalcheck.mx
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Faqsupport",
  methods: {
    trackFaqs: function () {
      this.$ga.event("Consult", "click_faqs_b2c", "home_b2c");
    },
    redirectPage() {
      this.$router.push('/faqs')
    }
  },
};
</script>
<style scoped>
.service-21 {
  font-family: "Montserrat", sans-serif;
  color: #ffffff;
  font-weight: 300;
}

.service-21.wrap-service21-box {
  background-size: cover;
  background-position: left center;
}

.ptb {
  padding: 4rem 0px 4rem 0px;
}

@media (max-width:1232px) {
  .ptb {
    padding: 4rem 0px 3rem 0px;
  }
}

@media (max-width:1212px) {
  .ptb {
    padding: 3rem 0px 3rem 0px;
  }
}

@media (max-width:1183px) {
  .ptb {
    padding: 3rem 0px 2.2rem 0px;
  }
}

@media (max-width:1120px) {
  .ptb {
    padding: 3rem 0px 1.9rem 0px;
  }
}

@media (max-width:1084px) {
  .ptb {
    padding: 2.6rem 0px 1.8rem 0px;
  }
}

@media (max-width:1043px) {
  .ptb {
    padding: 1.7rem 0px 1.3rem 0px;
  }
}

@media (max-width:1024px) {
  .ptb {
    padding: 2.2rem 0px 1.2rem 0px;
  }
}

@media (max-width:991px) {
  .service-21.wrap-service21-box {
    background-size: cover;
    background-position: left center;
  }
}

.overlay-gradient {
  position: relative;
}

.overlay-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* background: linear-gradient(to bottom, #4FC3F7, #8E24AA); */
  background: linear-gradient(90deg, transparent 0%, rgba(210, 210, 210, 1) 50%, rgba(142, 142, 142, 1) 100%);
  display: block;
  opacity: 0.55;
}

.overlay-content {
  z-index: 99;
  position: relative;
}

@media (max-width: 469px) {
  button .title-home {
    font-size: 12px !important;
  }

  .overlay-gradient::before {
    background: black;
  }
}

@media (max-width: 767px) {
  .overlay-content {
    text-align: center !important;
  }
}

.text-dark-tc {
  color: #343a40 !important;
}

@media (max-width: 767px) {
  .text-dark-tc {
    color: #ffffff !important;
  }
}
</style>
